import { ChangeEvent, useState } from 'react';

const PLACE_TYPES = [
  'establishment',
  'intersection',
  'route',
  'street_address',
  'street_number',
  'premise',
  'point_of_interest',
  'landmark',
];

export const useGoogleAddress = () => {
  const service = new google.maps.places.AutocompleteService();

  const [placeSuggestions, setPlaceSuggestions] = useState([]) as any;
  const [showSuggestionContainer, setShowSuggestionContainer] = useState(null) as any;
  const [addressValue, setAddressValue] = useState('') as any;
  const [bounds, setBounds] = useState({}) as any;

  const handleSuggestionSelect = (place: any) => {
    setAddressValue(place.description);
    setShowSuggestionContainer(false);
  };

  const clearAddressField = () => {
    setAddressValue('');
    setPlaceSuggestions([]);
  };

  const handleAddressChange = (event: ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    if (!input) {
      clearAddressField();
      return;
    }
    if (input) {
      setAddressValue(input);
      const defaultBounds = {
        north: bounds.lat + 0.6,
        south: bounds.lat - 0.6,
        east: bounds.lng + 0.6,
        west: bounds.lng - 0.6,
      };
      service.getPlacePredictions({ input, bounds: defaultBounds }, (address: any) => {
        if (address) {
          let suggestions: string[] = [];
          address.forEach((_address: any) => {
            if (_address?.types?.some((type: string)=> PLACE_TYPES.includes(type))) {
              if (suggestions.length < 4) {
                suggestions.push(_address);
              }
            }
          });
          setPlaceSuggestions(suggestions);
          setShowSuggestionContainer(true);
        }
      });
    } else {
      setPlaceSuggestions([]);
      setShowSuggestionContainer(false);
    }
  };

  const matchString = (place: any) => {
    const startTag = '<b className="m-1">';
    const endTag = '</b>';
    const startTagPosition = place.structured_formatting.main_text_matched_substrings?.[0]?.offset;
    const endTagPosition = startTagPosition + place.structured_formatting.main_text_matched_substrings?.[0]?.length;
    const mainText = place.structured_formatting.main_text;

    return { __html: [mainText.slice(0, startTagPosition), startTag, mainText.slice(startTagPosition, endTagPosition), endTag, mainText.slice(endTagPosition)].join('') };
  };

  return {
    placeSuggestions,
    showSuggestionContainer,
    setShowSuggestionContainer,
    addressValue,
    setAddressValue,
    handleSuggestionSelect,
    handleAddressChange,
    matchString,
    setBounds,
  };
};
